import {useCallback, useMemo} from 'react'
import {useAtom} from 'jotai/index'
import {atom} from 'jotai'

const showCookieOverlayAtom = atom<boolean>(false)

const useCookieOverlayState = () => {
    const [isCookieOverlayVisible, setIsCookieOverlayVisible] = useAtom(showCookieOverlayAtom)

    const showCookieOverlay = useCallback(() => {
        setIsCookieOverlayVisible(true)
    }, [setIsCookieOverlayVisible])

    const hideCookieOverlay = useCallback(() => {
        setIsCookieOverlayVisible(false)
    }, [setIsCookieOverlayVisible])

    return useMemo(
        () => ({
            isCookieOverlayVisible,
            showCookieOverlay,
            hideCookieOverlay,
        }),
        [isCookieOverlayVisible, showCookieOverlay, hideCookieOverlay]
    )
}

export default useCookieOverlayState
